/**
 * Safely convert any value to a renderable string.
 * Backend may return objects where strings are expected.
 */
export function safeText(val: unknown): string {
  if (val == null) return '';
  if (typeof val === 'string') return val;
  if (typeof val === 'number') return String(val);
  if (typeof val === 'object' && 'text' in (val as any)) return String((val as any).text || '');
  if (typeof val === 'object' && 'content' in (val as any)) return String((val as any).content || '');
  return JSON.stringify(val);
}
